import { Link } from '@tanstack/react-router'
import { REVIEW } from '@/content/offer'
import { OAC } from '@/content/oac'

export function Nav() {
  return (
    <nav className="sticky top-0 z-50 border-b border-[#232a26] bg-[#0e1110]/95 backdrop-blur-sm">
      <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-4">
        <Link
          to="/"
          className="text-lg font-semibold tracking-tight text-[#f0f3f1] transition-opacity hover:opacity-80"
        >
          control
          <span className="text-[#80cca5]">stack</span>
          <span className="text-[#8b958f]">.ai</span>
        </Link>

        {/* Guides and Resources are unpublished — the four markdown
            checklists behind them were generic enough to argue against the
            paid session. OpenAgents Control is the free thing now. */}
        <div className="flex items-center gap-5 md:gap-7">
          <a
            href={OAC.repoUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden text-sm text-[#c3ccc7] transition-colors hover:text-[#80cca5] sm:inline"
          >
            {OAC.short}
          </a>
          <Link
            to="/call"
            className="whitespace-nowrap rounded-lg bg-[#80cca5] px-3 py-2 text-sm font-semibold text-[#0e1110] transition-colors hover:bg-[#6bb890]"
          >
            Work with me
            <span className="hidden sm:inline"> — {REVIEW.price}</span>
          </Link>
        </div>
      </div>
    </nav>
  )
}
